import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  Layout,
  Drawer,
  Button,
  Tooltip,
  Input,
} from "antd";

import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DashboardOutlined,
  FileTextOutlined,
  CheckSquareOutlined,
  CloseOutlined,
  SearchOutlined,
} from "@ant-design/icons";

import { motion } from "framer-motion";

import AssignmentView from "../pages/Teachers/AssignmentView";
import StudentOverview from "./StudentOverview";

import UserSearchBox from "../SchoolDashApp/UserDetails/UserSearchBox";
import ProfileImage from "../NewDashboard/ProfileImage";

import PostTodoList from "../NewDashboard/CalenderAndTodo/PostTodoList";
import Darkmode from "../NewDashboard/Darkmode/Darkmode";

import NotificationIcon from "../components/ChatApp/NotificationIcon";
import Notice from "../components/ChatApp/Notice";
import ViewPlanCoursesList from "./PlanCourses/ViewPlanCoursesList";

import PlanCoursesPage from "./PlanCourses/PlanCoursesPage";
import MyLearningCoursesEnvironment from "./PlanCourses/MyLearningCoursesEnvironment";

import logo from "./cayeplogo.jpg";

const { Header, Sider, Content } = Layout;

const COLORS = {
  primary: "#3B4B8A",
  primaryDark: "#2E3A70",
  secondary: "#167A89",

  page: "#F5F7FB",
  pureWhite: "#FFFFFF",

  text: "#17233C",
  muted: "#667085",
  border: "#E1E6EF",
  soft: "#F8FAFD",

  success: "#16805C",
  warning: "#C88719",
  error: "#C44545",
  info: "#3B82A6",

  sidebar: "#101827",
  sidebarAlt: "#162033",
  sidebarBorder: "#26344C",

  sidebarText: "#DCE5F2",
  sidebarMuted: "#91A0B5",
  sidebarIcon: "#91A9C7",
  sidebarBright: "#7C9CFF",

  gold: "#C88719",
  yellow: "#D49A27",
  orange: "#C97B18",
  green: "#16805C",
  sky: "#3B82A6",
  antique: "#8795A8",

  black: "#101827",
  white: "#F4F7FB",
  gray: "#AAB6C6",

  shadow:
    "0 12px 35px rgba(23,35,60,.08)",
};

const menuItems = [
  {
    key: "overview",
    icon: <DashboardOutlined />,
    label: "Dashboard",
  },
    {
    key: "plancoursespage",
    icon: <FileTextOutlined />,
    label: "Plan Courses",
  },
  
  {
    key: "mycoursedetails",
    icon: <FileTextOutlined />,
    label: "My Course Details",
  }, 
    {
    key: "mylearning",
    icon: <FileTextOutlined />,
    label: "My Learning",
  },
  // {
  //   key: "studentsassignments",
  //   icon: <CheckSquareOutlined />,
  //   label: "Assignments",
  // },

];

const navigationSections = [
  {
    key: "student",
    title: "STUDENT PORTAL",
    items: [
      "overview",
      "plancoursespage",
      "mycoursedetails",
      "mylearning",
      "studentsassignments",
      
      
    ],
  },
];

const StudentDashboard = () => {
  const [collapsed, setCollapsed] =
    useState(false);

  const [drawerOpen, setDrawerOpen] =
    useState(false);

  const [darkMode, setDarkMode] =
    useState(false);

  const [activePage, setActivePage] =
    useState("overview");

  const [selectedUser, setSelectedUser] =
    useState(null);

  const [menuSearch, setMenuSearch] =
    useState("");

  const [todoOpen, setTodoOpen] =
    useState(false);

  const [isMobile, setIsMobile] =
    useState(
      typeof window !== "undefined"
        ? window.innerWidth < 900
        : false
    );

  const [isNavigating, setIsNavigating] =
    useState(false);

  const [pendingPage, setPendingPage] =
    useState(null);

  useEffect(() => {
    const handleResize = () => {
      const mobile =
        window.innerWidth < 900;

      setIsMobile(mobile);

      if (mobile) {
        setCollapsed(false);
      }
    };

    handleResize();

    window.addEventListener(
      "resize",
      handleResize
    );

    return () => {
      window.removeEventListener(
        "resize",
        handleResize
      );
    };
  }, []);

  useEffect(() => {
    const style =
      document.createElement("style");

    style.id =
      "cayep-student-dashboard-styles";

    style.innerHTML = `
      * {
        box-sizing: border-box;
      }

      html,
      body,
      #root {
        margin: 0;
        min-height: 100%;
      }

      body {
        overflow: hidden;
        background: #F5F7FB;
        color: #17233C;
      }

      ::-webkit-scrollbar {
        width: 7px;
        height: 7px;
      }

      ::-webkit-scrollbar-track {
        background: transparent;
      }

      ::-webkit-scrollbar-thumb {
        background: #A8B5C8;
        border-radius: 20px;
      }

      ::-webkit-scrollbar-thumb:hover {
        background: #3B4B8A;
      }

      * {
        scrollbar-width: thin;
        scrollbar-color:
          #A8B5C8
          transparent;
      }

      .student-menu-button {
        width: 39px !important;
        height: 39px !important;
        min-width: 39px !important;
        padding: 0 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        border-radius: 9px !important;
        border: 1px solid #E1E6EF !important;
        background: #FFFFFF !important;
        color: #43516B !important;
        box-shadow: none !important;
      }

      .student-menu-button:hover {
        color: #3B4B8A !important;
        border-color: #B9C4DE !important;
        background: #F0F3FA !important;
      }

      .student-dark .student-menu-button {
        background: #182236 !important;
        border-color: #2B3951 !important;
        color: #DCE5F2 !important;
      }

      .student-search-box
      .ant-input-affix-wrapper {
        min-height: 39px !important;
        border-radius: 9px !important;
        border: 1px solid #E1E6EF !important;
        background: #FFFFFF !important;
        box-shadow: none !important;
      }

      .student-search-box
      .ant-input-affix-wrapper:hover {
        border-color: #B9C4DE !important;
      }

      .student-search-box
      .ant-input-affix-wrapper-focused {
        border-color: #3B4B8A !important;
        box-shadow:
          0 0 0 2px rgba(59,75,138,.10) !important;
      }

      .student-search-box
      .ant-input {
        color: #17233C !important;
      }

      .student-search-box
      .ant-input::placeholder {
        color: #8793A5 !important;
      }

      .student-dark
      .student-search-box
      .ant-input-affix-wrapper {
        background: #182236 !important;
        border-color: #2B3951 !important;
      }

      .student-dark
      .student-search-box
      .ant-input {
        color: #F4F7FB !important;
      }

      .student-sidebar-search
      .ant-input-affix-wrapper {
        min-height: 39px !important;
        border-radius: 8px !important;
        background: #172236 !important;
        border: 1px solid #2A3951 !important;
        box-shadow: none !important;
      }

      .student-sidebar-search
      .ant-input-affix-wrapper:hover {
        border-color: #4D6194 !important;
      }

      .student-sidebar-search
      .ant-input {
        background: transparent !important;
        color: #E7EDF6 !important;
      }

      .student-sidebar-search
      .ant-input::placeholder {
        color: #8190A6 !important;
      }

      .student-sidebar-search
      .ant-input-affix-wrapper-focused {
        border-color: #3B4B8A !important;
        box-shadow:
          0 0 0 2px rgba(59,75,138,.18) !important;
      }

      .student-sidebar-scroll {
        scrollbar-width: thin;
        scrollbar-color:
          #33435C
          transparent;
      }

      .student-section-title {
        padding:
          16px 18px 7px;
        color: #8190A6;
        font-size: 9px;
        font-weight: 800;
        letter-spacing: 1.25px;
        user-select: none;
      }

      .student-nav-item {
        position: relative;
        width: calc(100% - 24px);
        min-height: 43px;
        margin: 2px 12px;
        padding: 0 12px;
        border: 0;
        border-radius: 8px;
        display: flex;
        align-items: center;
        gap: 11px;
        color: #C9D5E5;
        background: transparent;
        cursor: pointer;
        text-align: left;
        font-family: inherit;
        font-size: 13px;
        font-weight: 500;
        transition:
          background 150ms ease,
          color 150ms ease,
          transform 150ms ease;
      }

      .student-nav-item:hover {
        background:
          linear-gradient(
            90deg,
            rgba(59,75,138,.34),
            rgba(59,75,138,.12)
          );
        color: #FFFFFF;
      }

      .student-nav-item:hover
      .student-nav-icon {
        color: #8FA8FF;
        border-color:
          rgba(143,168,255,.20);
        background:
          rgba(143,168,255,.08);
      }

      .student-nav-item.active {
        background:
          linear-gradient(
            90deg,
            rgba(59,75,138,.66),
            rgba(22,122,137,.24)
          );
        color: #FFFFFF;
        font-weight: 700;
        box-shadow:
          0 6px 18px rgba(0,0,0,.18);
      }

      .student-nav-item.active::before {
        content: "";
        position: absolute;
        left: 0;
        top: 8px;
        bottom: 8px;
        width: 3px;
        border-radius: 0 3px 3px 0;
        background: #8FA8FF;
        box-shadow:
          0 0 10px rgba(143,168,255,.55);
      }

      .student-nav-item.active
      .student-nav-icon {
        color: #A6B9FF;
        border-color:
          rgba(166,185,255,.25);
        background:
          rgba(166,185,255,.10);
      }

      .student-nav-icon {
        width: 28px;
        height: 28px;
        min-width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 7px;
        color: #91A9C7;
        border: 1px solid transparent;
        font-size: 15px;
        transition: all 150ms ease;
      }

      .student-nav-label {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 1.2;
      }

      .student-nav-chevron {
        margin-left: auto;
        opacity: 0;
        transform: translateX(-3px);
        transition: all 150ms ease;
        color: #9EB1FF;
      }

      .student-nav-item:hover
      .student-nav-chevron,
      .student-nav-item.active
      .student-nav-chevron {
        opacity: 1;
        transform: translateX(0);
      }

      .student-collapsed-item {
        width: calc(100% - 18px);
        justify-content: center;
        margin-left: 9px;
        margin-right: 9px;
        padding: 0;
      }

      .student-collapsed-item
      .student-nav-chevron {
        display: none;
      }

      .student-collapsed-item
      .student-nav-label {
        display: none;
      }

      .student-collapsed-item
      .student-nav-icon {
        width: 34px;
        height: 34px;
        min-width: 34px;
      }

      .student-header-action {
        width: 39px;
        height: 39px;
        min-width: 39px;
        padding: 0;
        border-radius: 9px;
        border: 1px solid #E1E6EF;
        background: #FFFFFF;
        color: #43516B;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 160ms ease;
      }

      .student-header-action:hover {
        color: #3B4B8A;
        border-color: #B9C4DE;
        background: #F0F3FA;
      }

      .student-dark
      .student-header-action {
        background: #182236;
        border-color: #2B3951;
        color: #DCE5F2;
      }

      .student-profile-container {
        width: 40px;
        height: 40px;
        min-width: 40px;
        border-radius: 50%;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid #3B4B8A;
        background: #FFFFFF;
        box-shadow:
          0 3px 12px rgba(23,35,60,.14);
        position: relative;
      }

      .student-profile-avatar {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        border-radius: 50%;
      }

      .student-profile-container > *,
      .student-profile-avatar > * {
        width: 100% !important;
        height: 100% !important;
        min-width: 0 !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }

      .student-profile-container img,
      .student-profile-avatar img {
        width: 100% !important;
        height: 100% !important;
        min-width: 100% !important;
        min-height: 100% !important;
        object-fit: cover !important;
        object-position: center !important;
        display: block !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      .student-workspace {
        border: 1px solid #E1E6EF;
        background: #FFFFFF;
        border-radius: 11px;
        min-height: calc(100vh - 111px);
        box-shadow:
          0 4px 18px rgba(23,35,60,.035);
      }

      .student-workspace-dark {
        background: #182236;
        border-color: #2B3951;
      }

      .student-navigation-progress {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 3px;
        z-index: 1000;
        overflow: hidden;
        background: rgba(59,75,138,.12);
      }

      .student-navigation-progress::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 100%;
        background:
          linear-gradient(
            90deg,
            #3B4B8A,
            #167A89
          );
        box-shadow:
          0 0 8px rgba(59,75,138,.45);
        animation:
          studentNavigationProgress
          3s linear forwards;
      }

      @keyframes studentNavigationProgress {
        0% {
          width: 0%;
        }

        15% {
          width: 22%;
        }

        45% {
          width: 48%;
        }

        70% {
          width: 70%;
        }

        90% {
          width: 88%;
        }

        100% {
          width: 100%;
        }
      }

      .student-loading-label {
        position: absolute;
        top: 11px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1001;
        padding: 5px 10px;
        border-radius: 6px;
        background: rgba(16,24,39,.96);
        color: #FFFFFF;
        font-size: 9px;
        font-weight: 700;
        letter-spacing: .75px;
        text-transform: uppercase;
        white-space: nowrap;
        box-shadow:
          0 5px 15px rgba(0,0,0,.18);
      }

      .student-page-heading {
        min-height: 34px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        margin-bottom: 8px;
        padding: 0 2px;
      }

      .student-page-heading-left {
        min-width: 0;
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .student-page-heading-line {
        width: 4px;
        height: 18px;
        min-width: 4px;
        border-radius: 3px;
        background:
          linear-gradient(
            180deg,
            #3B4B8A,
            #167A89
          );
        box-shadow:
          0 0 7px rgba(59,75,138,.22);
      }

      .student-page-heading-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #17233C;
        font-size: 14px;
        font-weight: 750;
      }

      .student-dark
      .student-page-heading-title {
        color: #F3F6FA;
      }

      .student-page-heading-meta {
        color: #667085;
        font-size: 10px;
        font-weight: 600;
        white-space: nowrap;
        letter-spacing: .2px;
      }

      .student-dark
      .student-page-heading-meta {
        color: #9BA9BC;
      }

      .student-dark {
        color: #F3F6FA;
      }

      .student-dark
      .student-sidebar-search
      .ant-input-affix-wrapper {
        background: #172236 !important;
        border-color: #2B3951 !important;
      }

      .student-dark
      .student-sidebar-search
      .ant-input {
        color: #F3F6FA !important;
      }

      .student-dark
      .student-sidebar-search
      .ant-input::placeholder {
        color: #8190A6 !important;
      }

      .student-dark
      .student-nav-item {
        color: #C9D5E5;
      }

      .student-dark
      .student-nav-item:hover {
        background:
          linear-gradient(
            90deg,
            rgba(59,75,138,.38),
            rgba(22,122,137,.13)
          );
        color: #FFFFFF;
      }

      .student-dark
      .student-nav-item.active {
        background:
          linear-gradient(
            90deg,
            rgba(59,75,138,.68),
            rgba(22,122,137,.28)
          );
        color: #FFFFFF;
      }

      .student-dark
      .student-section-title {
        color: #8190A6;
      }

      .student-dark
      .student-page-heading-line {
        background:
          linear-gradient(
            180deg,
            #8FA8FF,
            #54B8C4
          );
      }

      .student-sidebar-shell {
        position: relative;
        overflow: hidden;
        background:
          linear-gradient(
            145deg,
            #101827 0%,
            #121D2E 45%,
            #101827 100%
          );
      }

      .student-sidebar-shell::before {
        content: "";
        position: absolute;
        inset: -40%;
        pointer-events: none;
        background:
          repeating-linear-gradient(
            118deg,
            transparent 0,
            transparent 72px,
            rgba(124,156,255,.045) 73px,
            rgba(124,156,255,.045) 75px,
            transparent 76px,
            transparent 145px
          );
        animation:
          studentSidebarStripes
          24s linear infinite;
        transform: translate3d(0,0,0);
      }

      .student-sidebar-shell::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 1px;
        pointer-events: none;
        background:
          linear-gradient(
            180deg,
            rgba(143,168,255,.10),
            rgba(143,168,255,.42),
            rgba(84,184,196,.08)
          );
        box-shadow:
          0 0 18px rgba(124,156,255,.10);
      }

      .student-sidebar-content {
        position: relative;
        z-index: 2;
        height: 100%;
      }

      @keyframes studentSidebarStripes {
        0% {
          transform:
            translate3d(-45px,-20px,0)
            rotate(0deg);
        }

        50% {
          transform:
            translate3d(45px,20px,0)
            rotate(1deg);
        }

        100% {
          transform:
            translate3d(-45px,-20px,0)
            rotate(0deg);
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .student-sidebar-shell::before {
          animation: none;
        }
      }

      @media (max-width: 899px) {
        .student-profile-container {
          width: 36px;
          height: 36px;
          min-width: 36px;
        }

        .student-workspace {
          min-height: calc(100vh - 96px);
          border-radius: 8px;
        }

        .student-page-heading {
          min-height: 30px;
        }

        .student-page-heading-title {
          font-size: 13px;
        }

        .student-page-heading-meta {
          display: none;
        }
      }

      @media (max-width: 560px) {
        .student-header-action {
          width: 36px;
          height: 36px;
          min-width: 36px;
        }

        .student-menu-button {
          width: 36px !important;
          height: 36px !important;
          min-width: 36px !important;
        }

        .student-profile-container {
          width: 34px;
          height: 34px;
          min-width: 34px;
        }

        .student-workspace {
          border-left: 0;
          border-right: 0;
          box-shadow: none;
        }
      }
    `;

    document.head.appendChild(style);

    return () => {
      const existing =
        document.getElementById(
          "cayep-student-dashboard-styles"
        );

      if (existing) {
        existing.remove();
      }
    };
  }, []);

  const theme = useMemo(
    () => ({
      darkMode,

      background: darkMode
        ? "#0D1522"
        : COLORS.page,

      sidebar: COLORS.sidebar,

      header: darkMode
        ? "#121D2E"
        : COLORS.pureWhite,

      card: darkMode
        ? "#182236"
        : COLORS.pureWhite,

      inputBackground: darkMode
        ? "#182236"
        : COLORS.pureWhite,

      text: darkMode
        ? "#F3F6FA"
        : COLORS.text,

      secondary: darkMode
        ? "#9BA9BC"
        : COLORS.muted,

      border: darkMode
        ? "#2B3951"
        : COLORS.border,

      primary: COLORS.primary,
      navy: COLORS.sidebar,
      blue: COLORS.secondary,
      gold: COLORS.gold,
      yellow: COLORS.yellow,
      orange: COLORS.orange,
      green: COLORS.green,
      sky: COLORS.sky,
      antique: COLORS.antique,
    }),
    [darkMode]
  );

  const menuLookup = useMemo(
    () =>
      Object.fromEntries(
        menuItems.map((item) => [
          item.key,
          item,
        ])
      ),
    []
  );

  const filteredSections = useMemo(() => {
    const query =
      menuSearch.trim().toLowerCase();

    if (!query) {
      return navigationSections;
    }

    return navigationSections
      .map((section) => ({
        ...section,
        items:
          section.items.filter(
            (key) =>
              menuLookup[key]?.label
                ?.toLowerCase()
                .includes(query)
          ),
      }))
      .filter(
        (section) =>
          section.items.length > 0
      );
  }, [menuSearch, menuLookup]);

  const activeTitle =
    selectedUser
      ? "User Details"
      : menuLookup[activePage]?.label ||
        "Dashboard";

  const renderPage = () => {
    if (selectedUser) {
      return (
        <div
          style={{
            width: "100%",
            padding: 4,
          }}
        >
          <div
            style={{
              padding: 20,
              borderRadius: 10,
              border: `1px solid ${theme.border}`,
              background: theme.card,
              color: theme.text,
            }}
          >
            User details are not available
            from the student portal.
          </div>
        </div>
      );
    }

    switch (activePage) {
      case "studentsassignments":
        return (
          <AssignmentView
            theme={theme}
          />
        );

      case "plancoursespage": 
        return (
          <PlanCoursesPage
            theme={theme}
          />
        ); 

      
            case "mycoursedetails": 
        return (
          <ViewPlanCoursesList
            theme={theme}
          />
        );

            case "mylearning":
        return (
          <MyLearningCoursesEnvironment
            theme={theme}
          />
        );

      case "overview":
      default:
        return (
          <StudentOverview
            theme={theme}
          />
        );
    }
  };

  const handleNavigation = (key) => {
    if (isNavigating) {
      return;
    }

    if (
      key === activePage &&
      !selectedUser
    ) {
      if (isMobile) {
        setDrawerOpen(false);
      }

      return;
    }

    setPendingPage(key);
    setIsNavigating(true);
    setSelectedUser(null);
    setMenuSearch("");

    if (isMobile) {
      setDrawerOpen(false);
    }

    window.setTimeout(() => {
      setActivePage(key);
      setPendingPage(null);
      setIsNavigating(false);
    }, 2000);
  };

  const renderNavigationItem = (item) => {
    const active =
      activePage === item.key &&
      !selectedUser;

    return (
      <Tooltip
        key={item.key}
        title={
          collapsed
            ? item.label
            : ""
        }
        placement="right"
      >
        <button
          type="button"
          className={[
            "student-nav-item",
            active
              ? "active"
              : "",
            collapsed
              ? "student-collapsed-item"
              : "",
          ].join(" ")}
          onClick={() =>
            handleNavigation(
              item.key
            )
          }
          disabled={isNavigating}
          aria-current={
            active
              ? "page"
              : undefined
          }
        >
          <span className="student-nav-icon">
            {item.icon}
          </span>

          <span className="student-nav-label">
            {item.label}
          </span>

          <span className="student-nav-chevron">
            <span
              style={{
                display: "flex",
                fontSize: 9,
              }}
            >
              ›
            </span>
          </span>
        </button>
      </Tooltip>
    );
  };

  const sidebar = (
    <div className="student-sidebar-shell">
      <div className="student-sidebar-content">
        <div
          style={{
            height: "100%",
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            background: "transparent",
          }}
        >
          <div
            style={{
              height: 72,
              minHeight: 72,
              display: "flex",
              alignItems: "center",
              justifyContent:
                collapsed
                  ? "center"
                  : "flex-start",
              gap: 11,
              padding: collapsed
                ? "0 10px"
                : "0 18px",
              borderBottom:
                "1px solid rgba(143,168,255,.11)",
            }}
          >
            <div
              style={{
                width: 38,
                height: 38,
                minWidth: 38,
                borderRadius: 8,
                padding: 2,
                background: "#FFFFFF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                border:
                  "1px solid rgba(143,168,255,.30)",
                boxShadow:
                  "0 4px 14px rgba(0,0,0,.25)",
              }}
            >
              <img
                src={logo}
                alt="CAYEP logo"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: 6,
                  display: "block",
                }}
              />
            </div>

            {!collapsed && (
              <div
                style={{
                  minWidth: 0,
                }}
              >
                <div
                  style={{
                    color: "#F4F7FB",
                    fontSize: 13,
                    fontWeight: 800,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    letterSpacing: ".15px",
                  }}
                >
                  CAYEP
                </div>

                <div
                  style={{
                    marginTop: 3,
                    color: "#8FA8FF",
                    fontSize: 8,
                    fontWeight: 800,
                    letterSpacing: 1.05,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  STUDENT PORTAL
                </div>
              </div>
            )}
          </div>

          {!collapsed && (
            <div
              className="student-sidebar-search"
              style={{
                padding:
                  "13px 12px 6px",
                flexShrink: 0,
              }}
            >
              <Input
                allowClear
                value={menuSearch}
                onChange={(event) =>
                  setMenuSearch(
                    event.target.value
                  )
                }
                placeholder="Find a module..."
                prefix={
                  <SearchOutlined
                    style={{
                      color:
                        COLORS.sidebarBright,
                    }}
                  />
                }
              />
            </div>
          )}

          <div
            className="student-sidebar-scroll"
            style={{
              flex: 1,
              minHeight: 0,
              overflowY: "auto",
              overflowX: "hidden",
              paddingBottom: 20,
            }}
          >
            {filteredSections.length ===
              0 && (
              <div
                style={{
                  padding:
                    "35px 20px",
                  textAlign: "center",
                  color: "#8190A6",
                  fontSize: 11,
                }}
              >
                No module found
              </div>
            )}

            {filteredSections.map(
              (section) => {
                const items =
                  section.items
                    .map(
                      (key) =>
                        menuLookup[key]
                    )
                    .filter(Boolean);

                if (!items.length) {
                  return null;
                }

                return (
                  <div
                    key={section.key}
                  >
                    {!collapsed ? (
                      <div className="student-section-title">
                        {section.title}
                      </div>
                    ) : (
                      <div
                        style={{
                          height: 12,
                        }}
                      />
                    )}

                    {items.map(
                      renderNavigationItem
                    )}
                  </div>
                );
              }
            )}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div
      className={
        darkMode
          ? "student-dark"
          : ""
      }
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 999,
        overflow: "hidden",
        background:
          theme.background,
      }}
    >
      <Layout
        style={{
          height: "100vh",
          minHeight: "100vh",
          background:
            theme.background,
        }}
      >
        {!isMobile && (
          <Sider
            width={292}
            collapsedWidth={78}
            collapsed={collapsed}
            trigger={null}
            style={{
              position: "fixed",
              top: 0,
              bottom: 0,
              left: 0,
              height: "100vh",
              zIndex: 100,
              overflow: "hidden",
              background:
                COLORS.sidebar,
            }}
          >
            {sidebar}
          </Sider>
        )}

        {isMobile && (
          <Drawer
            open={drawerOpen}
            placement="left"
            width={310}
            closable={false}
            onClose={() =>
              setDrawerOpen(false)
            }
            styles={{
              body: {
                padding: 0,
                background:
                  COLORS.sidebar,
              },
            }}
          >
            <div
              style={{
                position:
                  "absolute",
                top: 13,
                right: 13,
                zIndex: 20,
              }}
            >
              <Button
                type="text"
                icon={
                  <CloseOutlined />
                }
                onClick={() =>
                  setDrawerOpen(false)
                }
                style={{
                  width: 34,
                  height: 34,
                  color: "#DCE5F2",
                  background:
                    "rgba(143,168,255,.10)",
                  border:
                    "1px solid rgba(143,168,255,.15)",
                  borderRadius: 8,
                  display: "flex",
                  alignItems:
                    "center",
                  justifyContent:
                    "center",
                }}
              />
            </div>

            {sidebar}
          </Drawer>
        )}

        <Layout
          style={{
            marginLeft: isMobile
              ? 0
              : collapsed
                ? 78
                : 292,
            height: "100vh",
            minHeight: "100vh",
            background:
              theme.background,
            transition:
              "margin-left 180ms ease",
          }}
        >
          <Header
            style={{
              height: 68,
              minHeight: 68,
              flexShrink: 0,
              padding: isMobile
                ? "0 9px"
                : "0 16px",
              display: "flex",
              alignItems: "center",
              gap: isMobile ? 6 : 10,
              background:
                theme.header,
              borderBottom:
                `1px solid ${theme.border}`,
              position: "relative",
              zIndex: 30,
            }}
          >
            {isNavigating && (
              <>
                <div className="student-navigation-progress" />

                <div className="student-loading-label">
                  Opening{" "}
                  {menuLookup[
                    pendingPage
                  ]?.label || "module"}
                </div>
              </>
            )}

            <Button
              type="text"
              className="student-menu-button"
              icon={
                isMobile ? (
                  <MenuUnfoldOutlined />
                ) : collapsed ? (
                  <MenuUnfoldOutlined />
                ) : (
                  <MenuFoldOutlined />
                )
              }
              onClick={() => {
                if (isMobile) {
                  setDrawerOpen(true);
                } else {
                  setCollapsed(
                    (value) =>
                      !value
                  );
                }
              }}
            />

            <div
              className="student-search-box"
              style={{
                flex: 1,
                minWidth: 0,
                maxWidth: isMobile
                  ? 270
                  : 450,
              }}
            >
              <UserSearchBox
                theme={theme}
                setSelectedUser={
                  setSelectedUser
                }
                setActiveComponent={
                  setActivePage
                }
              />
            </div>

            <div
              style={{
                flex: 1,
                minWidth: 0,
              }}
            />

            <Tooltip title="Tasks">
              <button
                type="button"
                className="student-header-action"
                onClick={() =>
                  setTodoOpen(true)
                }
              >
                <CheckSquareOutlined />
              </button>
            </Tooltip>

            <PostTodoList
              open={todoOpen}
              setOpen={setTodoOpen}
            />

            <Darkmode
              darkMode={darkMode}
              setDarkMode={
                setDarkMode
              }
            />

            {!isMobile && (
              <>
                <NotificationIcon
                  theme={theme}
                />

                <Notice />
              </>
            )}

            <Tooltip title="Profile">
              <div className="student-profile-container">
                <div className="student-profile-avatar">
                  <ProfileImage
                    theme={theme}
                    header
                  />
                </div>
              </div>
            </Tooltip>
          </Header>

          <Content
            style={{
              background:
                theme.background,
              padding: isMobile
                ? "9px 8px 12px"
                : "14px 16px 18px",
              minHeight: 0,
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <div className="student-page-heading">
              <div className="student-page-heading-left">
                <span className="student-page-heading-line" />

                <span className="student-page-heading-title">
                  {activeTitle}
                </span>
              </div>

              {!isMobile && (
                <span className="student-page-heading-meta">
                  CAYEP • STUDENT PORTAL - Design By: Polu
                </span>
              )}
            </div>

            <motion.div
              key={
                selectedUser
                  ? "user-details"
                  : activePage
              }
              initial={{
                opacity: 0,
                y: 6,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.2,
                ease: "easeOut",
              }}
              className={
                darkMode
                  ? "student-workspace student-workspace-dark"
                  : "student-workspace"
              }
              style={{
                padding: isMobile
                  ? 9
                  : 15,
              }}
            >
              {renderPage()}
            </motion.div>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};

export default StudentDashboard;